import { render, staticRenderFns } from "./AddImgReview.vue?vue&type=template&id=94479324"
import script from "./AddImgReview.vue?vue&type=script&lang=js"
export * from "./AddImgReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports